import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';

import { createBrandSeriesRow, createDocumentsRow } from '../../lib/blocks';

import BanqueNationaleHeader from '../headers/BanqueNationaleHeader';
import HomePageBlocks, { HomePageBlocksProps } from './HomePageBlocks';

import styles from '../../styles/pages/home-page-quatre95.module.css';

function HomePageQuatre95({ brand, className = null, ...props }: HomePageBlocksProps) {
    const url = useUrlGenerator();
    const { sections } = brand;
    const banqueNationaleSection = (sections || []).find(
        (section) => section.slug === 'banque-nationale',
    );
    const { id: banqueNationaleSectionId } = banqueNationaleSection || {};
    const additionalBlocks = [
        createDocumentsRow(
            {
                brand: brand.id,
                section: banqueNationaleSectionId,
            },
            {
                className: styles.banqueNationaleSection,
                innerClassName: styles.inner,
                uniqueDocuments: false,
                count: 6,
                cardWidth: 150,
                minColumns: 2,
                withBorderRadius: false,
                cardWith: ['brand-icon'],
                header: <BanqueNationaleHeader className={styles.header} />,
                // withDescription: true,
            },
        ),
        createBrandSeriesRow(brand, {
            urlGenerator: url,
        }),
    ];
    return (
        <HomePageBlocks
            {...props}
            additionalBlocks={additionalBlocks}
            withoutSeries
            brand={brand}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

export default HomePageQuatre95;
